import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ColorLegend from "./ColorLegend";
import DataTable from "./DataTable";
import { styles } from "./DataTable.styles";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";
import Alert from "@mui/material/Alert";

const DomainNameReportSummary = ({
  formattedDomainSummary,
  domainSummaryColumns,
  getDetailedRowColor,
  expandAccordian,
  onAccordionChange,
  isMobile,
  showDomainReport,
  flipColumns,
}) => {
  if (!showDomainReport) {
    return (
      <>
        <Typography variant="h6" sx={styles.reportTitle}>
          Domain Name Availability Report
        </Typography>
        <Alert severity="info" icon={<ScreenRotationIcon />} sx={styles.alert}>
          Rotate your device to landscape mode to view report table.
        </Alert>
      </>
    );
  }

  return (
    <Accordion
      expanded={expandAccordian}
      onChange={onAccordionChange}
      sx={styles.accordion}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={styles.accordionTitle}>
          Domain Name Availability Report
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isMobile ? (
          <Alert
            severity="info"
            icon={<ScreenRotationIcon />}
            sx={styles.alert}
          >
            Rotate your device to landscape mode to view report table.
          </Alert>
        ) : (
          <>
            <ColorLegend
              legendText={[
                "High Availability (4-5)",
                "Medium Availability (2-3)",
                "Low Availability (0-1)",
              ]}
              legendColor={[
                styles.lowRiskColor,
                styles.mediumRiskColor,
                styles.highRiskColor,
              ]}
            />
            <DataTable
              columns={domainSummaryColumns}
              data={formattedDomainSummary}
              getRowColor={getDetailedRowColor}
              isReportData={false}
              sx={styles.dataTable}
              isMobile={isMobile}
              flipColumns={flipColumns}
            />
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default DomainNameReportSummary;
